import { observable } from "@legendapp/state";

import { user$ } from "../auth";
import { members$ } from "./members.store";
import type { Member } from "./members.types";

/**
 * The current user's membership in the active organization, or null.
 * Reactive: recomputes whenever user$ or members$ change.
 */
export const member$ = observable<Member | null>(() => {
  const userId = user$.id.get();
  if (!userId) return null;
  const all = members$.get() ?? [];
  return all.find((m) => m.userId === userId) ?? null;
});
